module.exports = __webpack_public_path__ + "static/media/fe.9b12d623.svg";